const { serialize } = require("../../utils");
export default {
  namespaced: true,
  state: {
    path: "aljabr/sales-department",
  },
  actions: {
    get({ dispatch, state, rootState }, options) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/?${serialize(options)}`,
            method: "GET",
            data: {},
          },
          { root: true }
        );
      }
    },
    // Sotuv bo'limi orqali tuzilgan barcha bekor qilingan shartnomalar
    canceledContracts({ dispatch, state, rootState }, options) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/canceled-contracts?${serialize(options)}`,
            method: "GET",
            data: {},
          },
          { root: true }
        );
      }
    },
    add({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/add`,
            method: "POST",
            data,
          },
          { root: true }
        );
      }
    },
    update({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/update`,
            method: "POST",
            data,
          },
          { root: true }
        );
      }
    },
    saveBranchDateTime({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/save-branch-date-time`,
            method: "POST",
            data,
          },
          { root: true }
        );
      }
    },
    saveContractData({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/save-contract-data`,
            method: "POST",
            data,
          },
          { root: true }
        );
      }
    },
    drag({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/drag`,
            method: "POST",
            data,
          },
          { root: true }
        );
      }
    },
    cancel({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/cancel`,
            method: "POST",
            data,
          },
          { root: true }
        );
      }
    },
    addStudentsAndContracts({ dispatch, state, rootState }, data) {
      if (rootState.authenticated) {
        return dispatch(
          "FETCH",
          {
            url: `${state.path}/add-students-and-contracts`,
            method: "POST",
            data,
          },
          { root: true }
        );
      }
    },
  },
};
